/**
 * VENNER — Complementos
 *
 *  · El recuadro de iniciales aparece cuando el cliente elige una variante de grabado.
 *  · Selector de variante propio, con el color de la variante, en lugar del desplegable del navegador.
 *  · Si la variante pide iniciales y el campo va vacío, se avisa antes de dejar agregar al carrito.
 */
/*
  El snippet incluye este archivo una vez por sección, así que en una página con varias (carrito, cajón,
  página de producto) el navegador lo ejecuta varias veces. Sin esta guarda los listeners se duplicaban y
  cada clic abría y cerraba el desplegable en el mismo gesto: parecía que no pasaba nada.
*/
if (!window.__vennerCrossSellReady) {
  window.__vennerCrossSellReady = true;

  const normaliza = (texto) => (texto || '').trim().toLowerCase();

  function pideIniciales(tarjeta, tituloVariante) {
    const triggers = (tarjeta.dataset.vxsTriggers || 'con grabado')
      .split(',')
      .map(normaliza)
      .filter(Boolean);

    return triggers.some((trigger) => normaliza(tituloVariante).includes(trigger));
  }

  /** Muestra u oculta el recuadro de iniciales según la variante elegida. */
  function sincroniza(tarjeta, tituloVariante) {
    const campo = tarjeta.querySelector('[data-vxs-initials]');

    if (!campo) return;

    const visible = pideIniciales(tarjeta, tituloVariante);
    const input = campo.querySelector('input');

    campo.toggleAttribute('hidden', !visible);

    if (input) {
      input.disabled = !visible;
      // `required` deja que también el formulario de Prestige frene el envío, no sólo nuestro listener.
      input.required = visible;
      if (!visible) {
        input.value = '';
        limpiaError(tarjeta);
      }
    }
  }

  function limpiaError(tarjeta) {
    const input = tarjeta.querySelector('.vxs__initials');
    const aviso = tarjeta.querySelector('[data-vxs-initials-error]');

    input?.removeAttribute('aria-invalid');
    aviso?.setAttribute('hidden', '');
  }

  function marcaError(tarjeta) {
    const input = tarjeta.querySelector('.vxs__initials');
    const aviso = tarjeta.querySelector('[data-vxs-initials-error]');

    input?.setAttribute('aria-invalid', 'true');
    aviso?.removeAttribute('hidden');
    input?.focus();
  }

  /**
   * Solo una tarjeta abierta a la vez: con varias, los paneles flotantes se montaban unos sobre otros.
   * Además se recoloca el panel si se saldría de la pantalla por la derecha.
   */
  function colocaPanel(tarjeta) {
    const panel = tarjeta?.querySelector('.vxs__options');

    if (!panel) return;

    panel.style.insetInlineStart = '';
    panel.style.insetInlineEnd = '';

    const caja = panel.getBoundingClientRect();

    if (caja.right > window.innerWidth - 8) {
      panel.style.insetInlineStart = 'auto';
      panel.style.insetInlineEnd = '0';
    }
  }

  function soloUnaAbierta(sw) {
    sw.closest('.vxs__list')?.querySelectorAll('.vxs__switch-input').forEach((otro) => {
      if (otro !== sw && otro.checked) otro.checked = false;
    });

    requestAnimationFrame(() => colocaPanel(sw.closest('[data-vxs-triggers]')));
  }

  document.addEventListener('change', (event) => {
    const sw = event.target.closest('.vxs__switch-input');

    if (sw && sw.checked) soloUnaAbierta(sw);
  });

  // El label dispara `change`, pero si alguna integración lo cambia por código, el clic lo cubre igual.
  document.addEventListener('click', (event) => {
    const label = event.target.closest('.vxs__switch');

    if (!label) return;

    requestAnimationFrame(() => {
      const sw = label.closest('[data-vxs-triggers]')?.querySelector('.vxs__switch-input');
      if (sw?.checked) soloUnaAbierta(sw);
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.vxs__switch-input:checked').forEach((sw) => {
      colocaPanel(sw.closest('[data-vxs-triggers]'));
    });
  });

  // ------------------------------------------------------------------ selector de variante

  function cierraTodos(excepto) {
    document.querySelectorAll('[data-vxs-picker]').forEach((picker) => {
      if (picker === excepto) return;
      picker.querySelector('[data-vxs-picker-toggle]')?.setAttribute('aria-expanded', 'false');
      picker.querySelector('[data-vxs-picker-list]')?.setAttribute('hidden', '');
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-vxs-picker-toggle]');
    const opcion = event.target.closest('[data-vxs-picker-option]');

    if (toggle) {
      const picker = toggle.closest('[data-vxs-picker]');
      const lista = picker.querySelector('[data-vxs-picker-list]');
      const abierto = toggle.getAttribute('aria-expanded') === 'true';

      cierraTodos(picker);
      toggle.setAttribute('aria-expanded', String(!abierto));
      lista.toggleAttribute('hidden', abierto);
      return;
    }

    if (opcion) {
      const picker = opcion.closest('[data-vxs-picker]');
      const tarjeta = opcion.closest('[data-vxs-triggers]');
      const input = tarjeta.querySelector('[data-vxs-variant-input]');
      const actual = picker.querySelector('[data-vxs-picker-current]');

      input.value = opcion.value;
      actual.innerHTML = opcion.innerHTML;

      picker.querySelectorAll('[data-vxs-picker-option]').forEach((o) => {
        o.setAttribute('aria-selected', String(o === opcion));
      });

      cierraTodos(null);
      sincroniza(tarjeta, opcion.textContent);
      return;
    }

    cierraTodos(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') cierraTodos(null);
  });

  // Las iniciales van siempre en mayúsculas, como en la página de producto.
  document.addEventListener('input', (event) => {
    const input = event.target.closest('.vxs__initials');

    if (!input) return;

    const posicion = input.selectionStart;
    const arriba = input.value.toUpperCase();

    if (arriba !== input.value) {
      input.value = arriba;
      input.setSelectionRange(posicion, posicion);
    }

    if (input.value.trim()) limpiaError(input.closest('[data-vxs-triggers]'));
  });

  /*
    Se valida en fase de captura para adelantarse al <product-form> de Prestige, que en cuanto recibe el
    submit lanza la petición al carrito. Sin esto, alguien podría pagar el grabado y no mandar iniciales.
  */
  // Si el bloqueo viene de la validación nativa, se pinta igualmente el aviso propio.
  document.addEventListener('invalid', (event) => {
    const input = event.target.closest?.('.vxs__initials');

    if (!input) return;

    /*
      preventDefault sobre `invalid` silencia el globo del navegador ("Fill out this field"), que además
      sale en inglés. El campo sigue siendo inválido, así que el formulario continúa bloqueado, y el
      aviso que ve el cliente es el nuestro.
    */
    event.preventDefault();
    marcaError(input.closest('[data-vxs-triggers]'));
  }, { capture: true });

  document.addEventListener('submit', (event) => {
    const tarjeta = event.target.closest('[data-vxs-triggers]');

    if (!tarjeta) return;

    const campo = tarjeta.querySelector('[data-vxs-initials]');
    const input = campo?.querySelector('input');

    if (!campo || campo.hasAttribute('hidden') || !input || input.disabled) return;

    if (!input.value.trim()) {
      event.preventDefault();
      event.stopPropagation();
      marcaError(tarjeta);
    }
  }, { capture: true });
}
